export default __webpack_public_path__ + "static/media/notes.458854ea.svg";